/* PlantSwitch theme · Shannon Cain, 2026
   3D tilt + light glare on product tiles, category cards and certificate cards (mouse only,
   skipped when reduced motion is on). The site cursor and magnetic buttons live in ps-motion.js;
   this file only adds cursor labels to cards that don't carry one. */
(function () {
  if (!matchMedia('(hover: hover) and (pointer: fine)').matches || matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var d = document;
  d.documentElement.classList.add('ps-pop');
  var TILT = '.ps-pt, .ps-sb__card, .ps-ct__card';
  var LABELS = [['.ps-sb__card', 'Shop'], ['.ps-pt__media', 'View'], ['.ps-pt__name a', 'View']];
  function tilt(el) {
    if (el.__tilt) return; el.__tilt = 1;
    var raf = 0, nx = 0, ny = 0, max = el.matches('.ps-ct__card') ? 5 : 8;
    el.addEventListener('pointerenter', function () { max = (el.matches('.ps-ct__card') ? 5 : 8) * Math.min(1, 360 / Math.max(1, el.offsetWidth)); });
    function paint() { raf = 0;
      el.style.setProperty('--trx', (-ny * max).toFixed(2) + 'deg'); el.style.setProperty('--try', (nx * max).toFixed(2) + 'deg');
      el.style.setProperty('--tgx', ((nx + 1) * 50).toFixed(1) + '%'); el.style.setProperty('--tgy', ((ny + 1) * 50).toFixed(1) + '%');
    }
    el.addEventListener('pointerenter', function () { el.classList.add('ps-tilt'); });
    el.addEventListener('pointermove', function (e) { var r = el.getBoundingClientRect(); nx = (e.clientX - r.left) / r.width * 2 - 1; ny = (e.clientY - r.top) / r.height * 2 - 1; if (!raf) raf = requestAnimationFrame(paint); });
    el.addEventListener('pointerleave', function () { nx = ny = 0; paint(); el.classList.remove('ps-tilt'); });
  }
  function scan() {
    d.querySelectorAll(TILT).forEach(tilt);
    LABELS.forEach(function (l) { d.querySelectorAll(l[0]).forEach(function (el) { if (!el.hasAttribute('data-cursor')) el.setAttribute('data-cursor', l[1]); }); });
    /* videos answer the site cursor first, so they need the label of the card they sit in */
    d.querySelectorAll('[data-cursor] video').forEach(function (v) { if (!v.hasAttribute('data-cursor')) v.setAttribute('data-cursor', v.closest('[data-cursor]').getAttribute('data-cursor')); });
  }
  function boot() { scan(); if (window.MutationObserver) new MutationObserver(function () { clearTimeout(boot.t); boot.t = setTimeout(scan, 200); }).observe(d.body, { childList: true, subtree: true }); }
  d.readyState !== 'loading' ? boot() : d.addEventListener('DOMContentLoaded', boot);
})();
